export default __webpack_public_path__ + "506f05a9e4dc2f92b4c1ca267004c120.svg";